export const labelsConstants = {
    LABELS_SUCCESS: 'LABELS_SUCCESS',
    LABELS_ERROR: 'LABELS_ERROR',
};

export const LabelType = {
    Contact: 1,
};
